<template>
    <div class="award-card reveal-bottom">
        <div class="card-img-box">
            <img class="card-img" :src="img" alt="img" />
        </div>

        <p class="card-p">{{ name }}</p>
    </div>
</template>
<script>
export default {
    props: {
        img: String,
        name: String,
    },
};
</script>
<style scoped>
.award-card {
    width: 297px;
    height: 280px;
    background: #f2f2f2;
    float: left;
    margin-right: 3px;
    margin-bottom: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.card-img-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 220px;
    padding-top: 20px;
    box-sizing: border-box;
}
.card-img {
    max-width: 227px;
    max-height: 170px;
    margin: 0 auto;
    display: block;
}
.card-p {
    height: 60px;
    font-size: 14px;
    color: #000000;
    text-align: center;
    line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Awards/Card.vue